module.exports = __webpack_public_path__ + "img/logo-icon.96d05140.png";